"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNewsStore = void 0;
const pinia_1 = require("pinia");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
exports.useNewsStore = (0, pinia_1.defineStore)('newsStore', {
    state: () => ({
        loading: false,
        news: [],
        article: null,
        totalNews: 0
    }),
    actions: {
        setLoading(loading) {
            this.loading = loading;
        },
        reset() {
            this.loading = false;
            this.news = [];
            this.article = null;
            this.totalNews = 0;
        },
        setNews(news, totalNews) {
            this.news = news;
            this.totalNews = totalNews;
        },
        setArticle(article) {
            this.article = article;
            this.loading = false;
        },
        async getNews(router, query) {
            var _a;
            this.setLoading(true);
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: 'admin_news_api', query: query }).href);
                const news = [];
                if (Array.isArray(response['hydra:member'])) {
                    response['hydra:member'].forEach(element => {
                        if (element['@type'] !== 'News') {
                            return;
                        }
                        news.push(element);
                    });
                }
                this.setNews(news, (_a = response['hydra:totalItems']) !== null && _a !== void 0 ? _a : 0);
                this.setLoading(false);
                return response;
            }
            catch (error) {
                console.error('Error fetching news:', error);
                this.setLoading(false);
                throw error;
            }
        },
        async getNewsByCategory(router, query) {
            var _a;
            this.setLoading(true);
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: 'admin_news_api_by_category', query: query }).href);
                const news = [];
                if (Array.isArray(response)) {
                    response.forEach(element => {
                        news.push(element);
                    });
                }
                this.setNews(news, (_a = response['hydra:totalItems']) !== null && _a !== void 0 ? _a : 0);
                this.setLoading(false);
                return response;
            }
            catch (error) {
                console.error('Error fetching news by category:', error);
                this.setLoading(false);
                throw error;
            }
        },
        async getArticle(router, id) {
            this.setLoading(true);
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: 'admin_news_api', params: { id } }).href);
                if (response['@type'] !== 'News') {
                    this.setLoading(false);
                    return response;
                }
                this.setArticle(response);
                return response;
            }
            catch (error) {
                console.error('Error fetching article:', error);
                this.setLoading(false);
                throw error;
            }
        },
        async createNews(router, news) {
            this.setLoading(true);
            const options = {
                body: JSON.stringify(news),
                method: 'POST'
            };
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: 'admin_news_api' }).href, options);
                this.setLoading(false);
                return response;
            }
            catch (error) {
                console.error('Error creating news:', error);
                this.setLoading(false);
                throw error;
            }
        },
        async updateNews(router, newsRequest, id) {
            this.setLoading(true);
            const options = {
                body: JSON.stringify(newsRequest),
                method: 'PUT'
            };
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: 'admin_news_api', params: { id: id } }).href, options);
                this.setLoading(false);
                return response;
            }
            catch (error) {
                console.error('Error updating news:', error);
                this.setLoading(false);
                throw error;
            }
        },
        async deleteNews(router, news) {
            this.setLoading(true);
            try {
                await (0, fetch_1.default)(router.resolve({ name: 'admin_news_api', params: { id: (Number(news.id)).valueOf() } }).href, { method: 'DELETE' });
                this.setLoading(false);
            }
            catch (error) {
                console.error('Error deleting news:', error);
                this.setLoading(false);
                throw error;
            }
        }
    }
});
